<template>
  <div class="text-center">
    <v-menu
      v-model="getMenuStatus"
      :close-on-content-click="false"
      offset-x
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-2" text color="primary" v-bind="attrs" v-on="on">
          <div>
            <v-icon class="mx-2">mdi-filter-variant</v-icon>
            <div
              v-if="nonDefaultFiltersApplied"
              style="position: absolute; top: -2px; left: 23px"
            >
              <v-icon x-small>mdi-circle</v-icon>
            </div>
          </div>
          {{ $t("components.general.filterMenu.filter") }}
        </v-btn>
      </template>

      <v-card max-width="470">
        <v-list v-if="headersAvailable">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                <v-icon class="mx-1">mdi-account-eye</v-icon>
                {{ $t("components.general.filterMenu.displayColumns") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-chip-group
              active-class="primary--text"
              v-model="headerSelection"
              @change="handleHeaderChange"
              multiple
              mandatory
              column
            >
              <v-chip
                v-for="(header, index) in getHeadersWithoutActions"
                :key="index"
                :value="header.value"
                outlined
              >
                {{ header.text }}
              </v-chip>
            </v-chip-group>
          </v-list-item>
        </v-list>

        <v-divider v-if="headersAvailable"></v-divider>

        <v-list v-if="filtersAvailable">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                <v-icon class="mx-1">mdi-filter</v-icon>
                <!-- {{ $t("components.general.filterMenu.filterTasksBy") }} -->
                {{ filters.title }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item> -->
          <v-card-text class="mt-0 pt-0">
            <v-chip-group
              v-for="(items, index) in getFilters"
              :key="index"
              active-class="primary--text"
              @change="handleFilterChange(false)"
              v-model="filterSelection[index]"
              mandatory
            >
              <!-- :multiple="items.multiple" -->
              <v-row no-gutters>
                <v-col cols="12">
                  <span class="ml-1">{{ items.title }}:</span>
                </v-col>

                <v-col cols="12">
                  <v-chip
                    v-for="(item, ind) in items.options"
                    :key="ind"
                    :value="item.value"
                    outlined
                    v-model="item.active"
                  >
                    {{ item.text }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-chip-group>
          </v-card-text>
          <!-- </v-list-item> -->
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import restrictions from "@/utils/restrictions";
export default {
  props: {
    menu: {
      type: Boolean,
      default: Boolean,
    },
    filters: {
      type: Object,
      default: Object,
    },
    headers: {
      type: Array,
      default: Array,
    },
    location: {
      type: String,
      default: String,
    },
  },
  created() {
    const { filters, headers } = this.getInitialUserOptions();
    this.filterSelection = filters;
    this.headerSelection = headers;

    this.handleHeaderChange(true);
    this.handleFilterChange(true);
  },
  data: () => ({
    filterSelection: [],
    headerSelection: [],
    query: {
      filters: null,
    },
  }),
  computed: {
    nonDefaultFiltersApplied() {
      return this.filters.items.some((item) => {
        return item.options.some((option) => {
          return this.filterSelection.includes(option.value) && !option.default;
        });
      });
    },
    getFilters() {
      return this.filters.items.filter((item) => {
        if (typeof item.feature === "undefined" || item.feature === null) {
          return item;
        }

        return !!restrictions.canUseCrmFeature(item.feature);
      });
    },
    getMenuStatus: {
      get: function () {
        return !!this.menu;
      },
      set: function (value) {
        this.$emit("close", value);
      },
    },
    getHeadersWithoutActions() {
      return this.headers.filter((item) => {
        return item.canHide;
      });
    },
    filtersAvailable() {
      return !!this.filters.title && this.filters.items.length !== 0;
    },
    headersAvailable() {
      return typeof this.headers !== "undefined" && !!this.headers.length;
    },
  },
  methods: {
    isLocalStorageAvailable() {
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.setItem("feature_test", "yes");
          if (localStorage.getItem("feature_test") === "yes") {
            localStorage.removeItem("feature_test");
            // localStorage is enabled
            return true;
          } else {
            // localStorage is disabled
            return false;
          }
        } catch (e) {
          // localStorage is disabled
          return false;
        }
      } else {
        // localStorage is not available
        return false;
      }
    },

    getInitialUserOptions(localStorageNotAvailable = false) {
      if (localStorageNotAvailable) {
        const defaultSettings = {
          headers: this.setDefaultHeaderSelections(),
          filters: this.setDefaultFilterSelections(),
        };
        return defaultSettings;
      }

      if (
        typeof localStorage.getItem(this.location) === "undefined" ||
        localStorage.getItem(this.location) === null
      ) {
        const defaultSettings = {
          headers: this.setDefaultHeaderSelections(),
          filters: this.setDefaultFilterSelections(),
        };

        localStorage.setItem(this.location, JSON.stringify(defaultSettings));

        return defaultSettings;
      }

      let filters = [];
      let headers = [];

      try {
        const data = JSON.parse(localStorage.getItem(this.location));
        filters = data.filters;
        headers = data.headers;
      } catch (error) {
        const defaultSettings = {
          headers: this.setDefaultHeaderSelections(),
          filters: this.setDefaultFilterSelections(),
        };

        localStorage.setItem(this.location, JSON.stringify(defaultSettings));

        return defaultSettings;
      }

      try {
        if (typeof headers === "undefined" || headers.length === 0) {
          headers = this.setDefaultHeaderSelections();
        }
      } catch (error) {
        headers = this.setDefaultHeaderSelections();
      }

      try {
        if (typeof filters === "undefined" || filters.length === 0) {
          filters = this.setDefaultFilterSelections();
        }
      } catch (error) {
        filters = this.setDefaultFilterSelections();
      }

      return { headers, filters };
    },

    setDefaultItem() {
      localStorage.setItem(
        this.location,
        JSON.stringify({
          filters: this.filterSelection,
          headers: this.headerSelection,
        })
      );
    },

    handleHeaderChange(initalLoad = false) {
      if (typeof localStorage.getItem(this.location) === "undefined") {
        this.$emit("update:headers", this.setDefaultHeaderSelections());
        return;
      }

      let localstoageItem = JSON.parse(localStorage.getItem(this.location));
      localStorage.setItem(
        this.location,
        JSON.stringify({
          ...localstoageItem,
          headers: this.headerSelection,
        })
      );
      this.$emit("update:headers", this.headerSelection, !initalLoad);
    },

    setDefaultHeaderSelections() {
      return this.headers.map((item) => {
        return item.value;
      });
    },

    setDefaultFilterSelections() {
      return this.filters.items.flatMap((item) => {
        return item.options
          .filter((item) => {
            return item.active;
          })
          .map((item) => {
            return item.value;
          });
      });
    },

    handleFilterChange(initalLoad = false) {
      if (typeof localStorage.getItem(this.location) === "undefined") {
        this.$emit("update:filters", this.setDefaultFilterSelections());
        this.query = {
          filters: this.setDefaultFilterSelections(),
        };
        return;
      }

      let localstoageItem = JSON.parse(localStorage.getItem(this.location));
      localStorage.setItem(
        this.location,
        JSON.stringify({
          ...localstoageItem,
          filters: this.filterSelection,
        })
      );

      let filter = this.filters.items
        .flatMap((item) =>
          item.options
            .filter((option) => this.filterSelection.includes(option.value))
            .map((item) => item.server)
        )
        .reduce((acc, curr) => {
          const { name, value } = curr;
          return { ...acc, [name]: value };
        }, {});

      // HACK: On a backend level, the "all" status is not a valid status
      if (this.location === "tasks" && filter.status === "all") {
        filter = null;
      }

      this.query = {
        ...filter,
      };
      this.$emit("update:filters", this.filterSelection, !initalLoad);
    },
  },
};
</script>
